<h2>{{'common.text_backoffice_user_resetPassword'|cxTranslate}}</h2>
<div class="pwdupdate-page mt-4">
  <div class="pwdupdate-container">
    <div class="pwdupdate-desc">
    </div>
    <div class="pwdupdate-form-block">
      <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="email">{{'common.basket_export_user_username'|cxTranslate}}</label>
          <input type="text" id="email" formControlName="email" class="email-style">
        </div>
        @if ((validEmail.email.invalid && validEmail.email.dirty)) {
          <div>
            <span class="text-danger">
              {{'common.pdp_validEmailText'|cxTranslate}}
            </span>
          </div>
        }

        @if(emailSent()){
          <div class="pwd-reset-email-sent-title">
            {{'common.account_confirmation_email_sent' | cxTranslate}}
          </div>
          <div class="pwd-reset-email-sent-desc">
            {{'common.account_confirmation_valid_email_sent' | cxTranslate}}
          </div>
        }
        <button type="submit" class=" btn btn-block btn-primary reset-btn" [disabled]="myForm.invalid">
          {{'common.text_account_profile_resetPassword'|cxTranslate}}
          <img src="/icons/link-white.svg" class="icon-right" alt="">
        </button>
      </form>
    </div>
  </div>
</div>